import React from "react";
import { withRouter } from "../_shared/withRouter";
import TermsComponent from "../template/_common/termsComponent";

const SuperAdminTerms = () => {
  return <TermsComponent roleType={"superadmin"} role={"2"} />;
};

export default withRouter(SuperAdminTerms);
